import AccountableLogo from 'components/atoms/AccountableLogo';
import { Button } from 'components/atoms/Button';
import { useIntercom } from 'hooks/intercom.hook';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { WEBAPP_LOGIN_ACCOUNTANT_CLICKEDOPENINTERCOM } from 'utils/amplitude/events/login.amplitude';

const ExpertAuthFooter: FC = () => {
  const { t } = useTranslation();
  const { showIntercom } = useIntercom();

  return (
    <footer className="flex justify-between items-center w-full">
      <div className="flex justify-center !font-semibold gap-2 items-center">
        <p className="text-sm text-primary-600">{t('need_help')}</p>
        <Button
          structure="text"
          className="text-primary-600"
          onClick={showIntercom}
          tracingEvent={WEBAPP_LOGIN_ACCOUNTANT_CLICKEDOPENINTERCOM}
        >
          <div className="first-letter:capitalize">{t('contact_us')}</div>
        </Button>
      </div>
      <span className="text-base">
        <AccountableLogo color="#7E4ADE" type="wordV2" />
      </span>
    </footer>
  );
};

export default ExpertAuthFooter;
